import { render, staticRenderFns } from "./PatientInsightsCard.vue?vue&type=template&id=88655c26&scoped=true"
import script from "./PatientInsightsCard.vue?vue&type=script&lang=js"
export * from "./PatientInsightsCard.vue?vue&type=script&lang=js"
import style0 from "./PatientInsightsCard.vue?vue&type=style&index=0&id=88655c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88655c26",
  null
  
)

export default component.exports